import React, { useState } from 'react'
import { connect } from 'react-redux'
import { team as teamModule } from 'redux/modules'
import { fetchClubAgeClasses } from 'api/ageClasses/api'
import PropTypes from 'prop-types'
import { Translate } from 'react-localize-redux'

import TeamEditForm from './TeamEditForm'

const TeamEditDialog = ({
  open,
  handleClose,
  updateTeam,
  team,
  currentClub,
}) => {
  const [teamUpdate, setTeamUpdate] = useState({
    ...team,
  })

  const [images, setImages] = useState([])

  const onChange = (imageList) => setImages(imageList)

  const handleSubmit = (values) => {
    const {
      country,
      gender,
      league,
      name,
      age_class: ageClass,
      tag,
    } = { ...values }

    let logo = null
    if (images.length > 0) {
      logo = images[0].file
    } else if (
      teamUpdate.relationships.logo &&
      teamUpdate.relationships.logo.full_url
    ) {
      logo = teamUpdate.relationships.logo.full_url
    }

    updateTeam(team.id, {
      country,
      gender,
      league,
      name,
      age_class: ageClass,
      tag,
      logo,
    }).then((res) => {
      const updatedTeam = res?.response?.data

      if (updatedTeam) {
        handleClose()
        setTeamUpdate({
          ...teamUpdate,
          logo: updatedTeam.logo,
        })
      }

      setImages([])
    })
  }

  const [ageClasses, SetAgeClasses] = useState([])

  const getAgeClasses = () => {
    fetchClubAgeClasses(currentClub.uuid)
      .then((res) => {
        SetAgeClasses(res.data)
      })
      .catch((e) => {
        console.error(e)
      })
  }
  const handleDialogClose = () => {
    handleClose()
  }
  React.useEffect(() => {
    getAgeClasses()
  }, [])

  return (
    <div>
      {ageClasses.length > 0 && (
        <TeamEditForm
          title={<Translate id="myteams.create-team" />}
          open={open}
          ageClasses={ageClasses}
          teamUpdate={teamUpdate}
          initialValues={{
            ...teamUpdate,
            logo: team.relationships.logo,
            tag: team.tag_name || null,
            // @todo After migrated to v2 api remove team.age_class_uuid usage
            // As on team update v1 success relationships.age_class not coming in response
            // So to show updated age class in edit dialog we are using team.age_class_uuid
            age_class: team.age_class_uuid || team.relationships.age_class.uuid,
          }}
          onClose={handleDialogClose}
          onSubmit={handleSubmit}
          images={images}
          handleImageChange={onChange}
        />
      )}
    </div>
  )
}

TeamEditDialog.defaultProps = {}

TeamEditDialog.propTypes = {
  handleClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  updateTeam: PropTypes.func.isRequired,
  team: PropTypes.shape().isRequired,
  currentClub: PropTypes.shape({
    uuid: PropTypes.string.isRequired,
  }).isRequired,
}

export default connect(
  ({ team, clubs: { current } }) => ({
    team,
    currentClub: current,
  }),
  {
    updateTeam: teamModule.updateTeam,
  }
)(TeamEditDialog)
